import { useEffect } from 'react'
import { createLocalStorageStateHook } from 'use-local-storage-state'
import { Centre } from '../../types/centre'

const LOCAL_STORAGE_KEY = 'recent-centres'

const useLocalStorage = createLocalStorageStateHook<string[]>(
  LOCAL_STORAGE_KEY,
  []
)

export const useRecentCentresTracker = (centre: Centre): void => {
  const [recentCentres, setRecentCentres] = useLocalStorage()

  useEffect(() => {
    // This hook can only work when we have a known centre slug
    // Also, there's no need to unshift the centre to the start if it's already
    // there.
    if (
      recentCentres &&
      recentCentres.length &&
      recentCentres[0] === centre.slug
    ) {
      return
    }

    const newRecentCentres = [
      centre.slug,
      ...(recentCentres || []).filter(slug => slug !== centre.slug),
    ]

    setRecentCentres(newRecentCentres)
  }, [centre.slug, recentCentres, setRecentCentres]) // Only run once per page load
}

export const useRecentCentres = (): string[] => {
  const [recentCentres] = useLocalStorage()
  return recentCentres || []
}
